import BBConsorcios from 'assets/img/bb-consorcio.svg';
import BBSeguros from 'assets/img/bb-seguros.svg';
import Livelo from 'assets/img/livelo-icon.svg';
import { FOCO_VISIVEL } from 'utils/foco';

/** Acesso ao catálogo Livelo e caixa "Apoio" do 1S2023, no visual novo (PREM-15). */
export default function CatalogoLivelo1S2023() {
  return (
    <section aria-label="Catálogo Livelo" className="mb-4 flex flex-col gap-5 rounded-2xl bg-brand-white p-6 shadow-jj-01 lg:flex-row lg:items-center">
      <div className="flex-1">
        <p tabIndex={0} className={`m-0 text-[13px] leading-[1.6] text-content ${FOCO_VISIVEL}`}>
          Acesse o catálogo de experiências clicando no botão "Acessar catálogo Livelo" para escolher seu prêmio e obter descontos
          exclusivos! Não se esqueça de utilizar o cupom JOGAJUNTOBB ou JOGAJUNTO20.
        </p>
        <a
          href="https://www.livelo.com.br/jogajuntobb"
          target="_blank"
          rel="noopener noreferrer"
          className={`mt-4 inline-block rounded-md bg-brand-blue px-6 py-3 font-display text-[13px] font-bold uppercase text-brand-white no-underline hover:bg-brand-blue-dark hover:text-brand-white hover:no-underline ${FOCO_VISIVEL}`}
        >
          Acessar catálogo Livelo<span className="sr-only"> (abre em nova aba)</span>
        </a>
      </div>
      <div className="flex items-center gap-4">
        <p className="m-0 font-display text-[13px] font-bold text-brand-blue-dark">Apoio:</p>
        <img src={BBSeguros} alt="BB Seguros" className="h-8" />
        <img src={Livelo} alt="Livelo" className="h-8" />
        <img src={BBConsorcios} alt="BB Consórcios" className="h-8" />
      </div>
    </section>
  );
}
